/* ==========================================================================
   BentoKids Theme JS
   ========================================================================== */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     CART MODULE
     - Cart drawer open/close
     - Render cart items
     - Add to Cart (ATC)
     - Qty stepper in drawer
     - Remove item
     - Header cart count badge
  ------------------------------------------------------------------ */
  var BKCart = {
    FREE_SHIPPING_THRESHOLD: parseInt(
      document.documentElement.dataset.freeShipping || '0', 10
    ),

    open: function () {
      var drawer = document.getElementById('cart-drawer');
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      BKCart.refresh();
    },

    close: function () {
      var drawer = document.getElementById('cart-drawer');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },

    refresh: function () {
      fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          BKCart.renderDrawer(cart);
          BKCart.updateBadge(cart.item_count);
        });
    },

    renderDrawer: function (cart) {
      var body = document.getElementById('cart-drawer-body');
      var foot = document.getElementById('cart-drawer-foot');
      if (!body || !foot) return;

      if (!cart.item_count) {
        body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a href="/collections/all">Start shopping &rarr;</a></div>';
        foot.innerHTML = '';
        return;
      }

      // Free shipping bar
      var shippingHtml = '';
      var threshold = BKCart.FREE_SHIPPING_THRESHOLD;
      if (threshold > 0) {
        var subtotalRs = cart.total_price / 100;
        var remaining = threshold - subtotalRs;
        if (remaining > 0) {
          var pct = Math.min((subtotalRs / threshold) * 100, 100);
          shippingHtml = '<div class="drawer-shipping-bar"><p class="drawer-shipping-bar__msg">Add <strong>Rs. ' + Math.ceil(remaining) + '</strong> more for free shipping!</p><div class="drawer-shipping-bar__track"><div class="drawer-shipping-bar__fill" style="width:' + pct + '%"></div></div></div>';
        } else {
          shippingHtml = '<div class="drawer-shipping-bar"><p class="drawer-shipping-bar__msg drawer-shipping-bar__msg--done">You\'ve unlocked free shipping!</p></div>';
        }
      }

      body.innerHTML = cart.items.map(function (item) {
        var img = item.image
          ? '<img src="' + item.image.replace('.jpg', '_120x120.jpg') + '" alt="' + BKCart.esc(item.title) + '" width="72" height="72" loading="lazy">'
          : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<p class="drawer-item__variant">' + BKCart.esc(item.variant_title) + '</p>'
          : '';
        return '<div class="drawer-item" data-key="' + item.key + '">'
          + '<div class="drawer-item__img">' + img + '</div>'
          + '<div class="drawer-item__info">'
          + '<p class="drawer-item__title">' + BKCart.esc(item.product_title) + '</p>'
          + variant
          + '<p class="drawer-item__price">' + BKCart.money(item.final_line_price) + '</p>'
          + '<div class="drawer-item__controls">'
          + '<button class="drawer-item__qty-btn js-drawer-minus" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">&#8722;</button>'
          + '<span class="drawer-item__qty-val">' + item.quantity + '</span>'
          + '<button class="drawer-item__qty-btn js-drawer-plus" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">&#43;</button>'
          + '</div></div>'
          + '<button class="drawer-item__remove js-drawer-remove" data-key="' + item.key + '" aria-label="Remove">&#x2715;</button>'
          + '</div>';
      }).join('');

      foot.innerHTML = shippingHtml
        + '<div class="drawer-subtotal"><span class="drawer-subtotal__label">Subtotal</span><span class="drawer-subtotal__amount">' + BKCart.money(cart.total_price) + '</span></div>'
        + '<a href="/checkout" class="btn btn--solid-green drawer-checkout">Checkout</a>'
        + '<a href="/cart" class="drawer-view-cart">View cart</a>';

      // Bind qty & remove buttons in drawer
      body.querySelectorAll('.js-drawer-minus, .js-drawer-plus').forEach(function (btn) {
        btn.addEventListener('click', function () {
          BKCart.updateQty(btn.dataset.key, parseInt(btn.dataset.qty, 10));
        });
      });
      body.querySelectorAll('.js-drawer-remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          BKCart.updateQty(btn.dataset.key, 0);
        });
      });
    },

    updateQty: function (key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          BKCart.renderDrawer(cart);
          BKCart.updateBadge(cart.item_count);
          // Update cart page subtotal if visible
          var el = document.getElementById('cart-page-subtotal');
          if (el) el.textContent = BKCart.money(cart.total_price);
        });
    },

    addItem: function (variantId, qty, title) {
      var btn = document.querySelector('[data-variant-id="' + variantId + '"]');
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Could not add to cart');
          return r.json();
        })
        .then(function () {
          if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
          BKCart.open();
        })
        .catch(function (err) {
          if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
          alert(err.message || 'Something went wrong. Please try again.');
        });
    },

    bindATC: function () {
      document.querySelectorAll('.product-card__atc').forEach(function (btn) {
        if (btn.dataset.atcBound) return;
        btn.dataset.atcBound = '1';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          BKCart.addItem(btn.dataset.variantId, 1, btn.dataset.productTitle);
        });
      });
    },

    updateBadge: function (count) {
      document.querySelectorAll('.cart-count-badge').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'inline-flex' : 'none';
      });
    },

    money: function (cents) {
      return 'Rs.' + (cents / 100).toLocaleString('en-PK', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    esc: function (str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
  };

  // Expose globally for theme.liquid button
  window.BKCart = BKCart;

  /* ------------------------------------------------------------------
     PRODUCT PAGE MODULE
     - Variant switching
     - Gallery thumbnails
     - Qty +/- buttons
     - Product form ATC
     - Accordion
  ------------------------------------------------------------------ */
  var BKProduct = {
    init: function () {
      if (!window.__BK_PRODUCT__) return;
      var product = window.__BK_PRODUCT__;

      // Build variants map: option combo → variant object
      var variantMap = {};
      product.variants.forEach(function (v) {
        variantMap[v.id] = v;
        var key = [v.option1, v.option2, v.option3].filter(Boolean).join('|');
        variantMap[key] = v;
      });

      var selectedOptions = [];
      var swatches = document.querySelectorAll('.product-option__swatch');
      swatches.forEach(function (sw) {
        var idx = parseInt(sw.dataset.optionIndex, 10);
        if (!selectedOptions[idx]) {
          // Set initial from active
          if (sw.classList.contains('active')) selectedOptions[idx] = sw.dataset.value;
        }
        sw.addEventListener('click', function () {
          // Deactivate siblings
          document.querySelectorAll('[data-option-index="' + idx + '"]').forEach(function (s) {
            s.classList.remove('active');
          });
          sw.classList.add('active');
          selectedOptions[idx] = sw.dataset.value;
          BKProduct.updateVariant(product, variantMap, selectedOptions);
        });
      });

      // Qty +/-
      var qtyInput = document.getElementById('product-qty');
      var minusBtn = document.querySelector('.js-qty-minus');
      var plusBtn = document.querySelector('.js-qty-plus');
      if (qtyInput && minusBtn && plusBtn) {
        minusBtn.addEventListener('click', function () {
          var v = parseInt(qtyInput.value, 10);
          if (v > 1) qtyInput.value = v - 1;
        });
        plusBtn.addEventListener('click', function () {
          var v = parseInt(qtyInput.value, 10);
          qtyInput.value = v + 1;
        });
      }

      // Gallery thumbnails
      document.querySelectorAll('.product-gallery__thumb').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          document.querySelectorAll('.product-gallery__thumb').forEach(function (t) { t.classList.remove('active'); });
          thumb.classList.add('active');
          var mainImg = document.getElementById('product-main-image');
          if (mainImg) mainImg.src = thumb.dataset.imageUrl;
        });
      });

      // Product form ATC submit
      var form = document.getElementById('product-form');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var variantId = document.getElementById('selected-variant-id').value;
          var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
          BKCart.addItem(variantId, qty, product.title);
        });
      }

      // Accordion
      document.querySelectorAll('.product-accordion__toggle').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var body = document.getElementById(btn.getAttribute('aria-controls'));
          if (!body) return;
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', !isOpen);
          body.hidden = isOpen;
          var icon = btn.querySelector('.product-accordion__icon');
          if (icon) icon.textContent = isOpen ? '+' : '−';
        });
      });
    },

    updateVariant: function (product, variantMap, selectedOptions) {
      var key = selectedOptions.filter(function (o) { return o !== undefined; }).join('|');
      var variant = variantMap[key];
      if (!variant) return;

      // Update hidden input
      var idInput = document.getElementById('selected-variant-id');
      if (idInput) idInput.value = variant.id;

      // Update price
      var priceEl = document.getElementById('product-price');
      if (priceEl) {
        var html = '';
        if (variant.compare_at_price > variant.price) {
          html += '<span class="product-info__compare-price">' + BKCart.money(variant.compare_at_price * 100) + '</span>';
        }
        html += '<span class="product-info__sale-price">' + BKCart.money(variant.price * 100) + '</span>';
        priceEl.innerHTML = html;
      }

      // Update image
      if (variant.featured_image) {
        var mainImg = document.getElementById('product-main-image');
        if (mainImg) mainImg.src = variant.featured_image.src;
      }

      // Update availability
      var avail = document.getElementById('product-availability');
      var atcBtn = document.getElementById('product-atc-btn');
      if (avail) {
        avail.textContent = variant.available ? 'In stock' : 'Out of stock';
        avail.className = 'product-info__availability ' + (variant.available ? 'product-info__availability--in' : 'product-info__availability--out');
      }
      if (atcBtn) {
        atcBtn.textContent = variant.available ? 'Add to Cart' : 'Out of Stock';
        atcBtn.disabled = !variant.available;
        atcBtn.classList.toggle('btn--disabled', !variant.available);
      }

      // Update SKU
      var skuEl = document.getElementById('product-sku');
      if (skuEl && variant.sku) skuEl.textContent = variant.sku;

      // Update URL without reload
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  };

  /* ------------------------------------------------------------------
     WISHLIST MODULE
     - localStorage-based
     - Toggle heart icons
     - Update header count badge
  ------------------------------------------------------------------ */
  var BKWishlist = {
    KEY: 'bk_wishlist',

    get: function () {
      try { return JSON.parse(localStorage.getItem(BKWishlist.KEY) || '[]'); }
      catch (e) { return []; }
    },

    save: function (list) {
      localStorage.setItem(BKWishlist.KEY, JSON.stringify(list));
    },

    toggle: function (handle) {
      var list = BKWishlist.get();
      var idx = list.indexOf(handle);
      if (idx === -1) list.push(handle);
      else list.splice(idx, 1);
      BKWishlist.save(list);
      BKWishlist.updateBadge();
      return idx === -1; // true = added
    },

    init: function () {
      var list = BKWishlist.get();
      document.querySelectorAll('.js-wishlist-toggle').forEach(function (btn) {
        if (btn.dataset.wishlistBound) return;
        btn.dataset.wishlistBound = '1';
        var handle = btn.dataset.productHandle;
        // Set initial state
        if (list.indexOf(handle) !== -1) btn.classList.add('active');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var added = BKWishlist.toggle(handle);
          btn.classList.toggle('active', added);
        });
      });
      BKWishlist.updateBadge();
    },

    updateBadge: function () {
      var count = BKWishlist.get().length;
      document.querySelectorAll('.wishlist-count-badge').forEach(function (el) {
        el.textContent = count;
        el.style.display = count > 0 ? 'inline-flex' : 'none';
      });
    }
  };

  window.BKWishlist = BKWishlist;

  /* ------------------------------------------------------------------
     TESTIMONIALS SLIDER
     Simple prev/next cycling through cards via scroll
  ------------------------------------------------------------------ */
  function initTestimonialsSlider() {
    document.querySelectorAll('.testimonials__controls').forEach(function (controls) {
      var trackId = controls.querySelector('[data-track]').dataset.track;
      var track = document.getElementById(trackId);
      if (!track) return;

      var cardWidth = function () {
        var card = track.querySelector('.testimonials__card');
        return card ? card.offsetWidth + 20 : 300;
      };

      controls.querySelector('.testimonials__btn--prev').addEventListener('click', function () {
        track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
      });
      controls.querySelector('.testimonials__btn--next').addEventListener('click', function () {
        track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
      });

      // Make track scrollable on mobile
      track.style.overflowX = 'auto';
      track.style.scrollSnapType = 'x mandatory';
      track.style.display = 'flex';
      track.style.gap = '20px';
      Array.from(track.children).forEach(function (card) {
        card.style.scrollSnapAlign = 'start';
        card.style.flexShrink = '0';
        card.style.width = 'clamp(260px, 80vw, 340px)';
      });
      // Hide scrollbar visually
      track.style.scrollbarWidth = 'none';
    });
  }

  /* ------------------------------------------------------------------
     BRAND VIDEO — lazy iframe on poster click
  ------------------------------------------------------------------ */
  function initBrandVideo() {
    document.querySelectorAll('.brand-video__poster').forEach(function (poster) {
      poster.addEventListener('click', function () {
        var videoId = poster.dataset.videoId;
        if (!videoId) return;
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
        iframe.className = 'brand-video__iframe';
        iframe.allow = 'autoplay; encrypted-media; fullscreen';
        iframe.setAttribute('allowfullscreen', '');
        poster.innerHTML = '';
        poster.appendChild(iframe);
      });
    });
  }

  /* ------------------------------------------------------------------
     CART PAGE — qty stepper & remove
  ------------------------------------------------------------------ */
  function initCartPage() {
    document.querySelectorAll('.js-cart-qty-minus, .js-cart-qty-plus').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.key;
        var qty = parseInt(btn.dataset.qty, 10);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            BKCart.updateBadge(cart.item_count);
            var subtotal = document.getElementById('cart-page-subtotal');
            if (subtotal) subtotal.textContent = BKCart.money(cart.total_price);
            // Reload page to re-render line items accurately
            if (qty === 0 || cart.item_count === 0) window.location.reload();
            else {
              var row = btn.closest('.cart-item');
              var item = cart.items.find(function (i) { return i.key === key; });
              if (row && item) {
                var qtyVal = row.querySelector('.cart-item__qty-val');
                var priceVal = row.querySelector('.cart-item__price');
                var minusBtn = row.querySelector('.js-cart-qty-minus');
                var plusBtn = row.querySelector('.js-cart-qty-plus');
                if (qtyVal) qtyVal.textContent = item.quantity;
                if (priceVal) priceVal.textContent = BKCart.money(item.final_line_price);
                if (minusBtn) minusBtn.dataset.qty = item.quantity - 1;
                if (plusBtn) plusBtn.dataset.qty = item.quantity + 1;
              }
            }
          });
      });
    });

    document.querySelectorAll('.js-cart-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            BKCart.updateBadge(cart.item_count);
            window.location.reload();
          });
      });
    });
  }

  /* ------------------------------------------------------------------
     INIT
  ------------------------------------------------------------------ */
  document.addEventListener('DOMContentLoaded', function () {
    // Inject free shipping threshold into dataset so BKCart can read it
    var fsThreshold = document.documentElement.dataset.freeShipping;
    if (!fsThreshold) {
      // Threshold comes from global settings — injected inline via Liquid if set
    }

    // Cart badge initial count
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { BKCart.updateBadge(cart.item_count); });

    // Bind all ATC buttons (product cards)
    BKCart.bindATC();

    // Product page
    BKProduct.init();

    // Wishlist
    BKWishlist.init();

    // Testimonials slider
    initTestimonialsSlider();

    // Brand video
    initBrandVideo();

    // Cart page AJAX
    initCartPage();

    // Close cart drawer on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') BKCart.close();
    });
  });

})();
